'use client';

import React, { useEffect, useState } from 'react';
import "./MatchStatistics.scss";
import NoData from "@/components/client/NoData";
import DataMatchStatistics from "@/components/client/DataMatchStatistics";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import MatchServices from "@/services/MatchServices";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES.src;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES.src;

export default function MatchStatistics({ match }) {
  const [matchHalfFullAnalysis, setMatchHalfFullAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatchData = async () => {
      try {
        if (match?.id) {
          const data = await MatchServices.getMatchHalfFullAnalysis(match.id);
          setMatchHalfFullAnalysis(data);
        }
      } catch (error) {
        console.error("Error fetching match data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatchData();
  }, [match]);

  if (loading) {
    return (
      <CollapsiblePanel
        title="Thống Kê HT/FT (2 mùa giải gần đây) "
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <NoData message="Đang tải dữ liệu..." />
      </CollapsiblePanel>
    );
  }

  if (!match || !matchHalfFullAnalysis) {
    return (
      <CollapsiblePanel
        title="Thống Kê HT/FT (2 mùa giải gần đây) "
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        {match?.status === "-1" ? (
          <NoData message="Không có dữ liệu" />
        ) : (
          <NoData message="Đang cập nhật..." />
        )}
      </CollapsiblePanel>
    );
  }

  return (
    <CollapsiblePanel
      title="Thống Kê HT/FT (2 mùa giải gần đây) "
      initOpen={true}
      iconUp={IMAGE_ARROW_UP_LEAGUES}
      iconDown={IMAGE_ARROW_DOWN_LEAGUES}
    >
      <DataMatchStatistics match={match} data={matchHalfFullAnalysis} />
    </CollapsiblePanel>
  );
}
